import React from 'react';
import {
  faUserPlus,
  faCalendarPlus,
  faUsers,
  faCalendarCheck
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type QuickActionColor = 'blue' | 'green' | 'purple' | 'orange';

interface QuickAction {
  title: string;
  description: string;
  icon: IconDefinition;
  color: QuickActionColor;
  onClick: () => void;
}

export default function QuickActions(): React.ReactElement {
  const navigate = useNavigate();

  const actions: QuickAction[] = [
    {
      title: 'Nova Consulta',
      description: 'Agendar nova consulta',
      icon: faCalendarPlus,
      color: 'blue',
      onClick: () => navigate('/consultas/create')
    },
    {
      title: 'Novo Paciente',
      description: 'Cadastrar novo paciente',
      icon: faUserPlus,
      color: 'green',
      onClick: () => navigate('/pacientes/create')
    },
    {
      title: 'Ver Pacientes',
      description: 'Gerenciar pacientes',
      icon: faUsers,
      color: 'purple',
      onClick: () => navigate('/pacientes')
    },
    {
      title: 'Ver Consultas',
      description: 'Gerenciar consultas',
      icon: faCalendarCheck,
      color: 'orange',
      onClick: () => navigate('/consultas')
    }
  ];

  const colorClasses: Record<QuickActionColor, string> = {
    blue: 'bg-blue-600 hover:bg-blue-700',
    green: 'bg-green-600 hover:bg-green-700',
    purple: 'bg-purple-600 hover:bg-purple-700',
    orange: 'bg-orange-600 hover:bg-orange-700'
  };

  return (
    <div className="bg-white rounded-lg border shadow-sm p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Ações Rápidas</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className={`${colorClasses[action.color]} text-white p-4 rounded-lg transition-colors duration-200 text-left`}
          >
            <div className="flex items-start space-x-3">
              <FontAwesomeIcon icon={action.icon} className="w-6 h-6 mt-1" />
              <div>
                <p className="font-medium">{action.title}</p>
                <p className="text-sm opacity-90">{action.description}</p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}